import React, {useEffect, useState} from "react";

import {Formik, FormikHelpers} from "formik";
import {Field, Form} from "../../designSystem/Form";
import {Button} from "../../designSystem/Button";
import Container from "../Container";
import {getClubs, getLigues} from "../../services/controllers";
import {APIGetClubsResponse, APIGetLiguesResponse, Club, Ligue} from "../../services/facade";
import LiveSearch from "../../designSystem/LiveSearchBar";
import {scrollToTop} from "../../utils/utils";

export interface AffiliationFormProps {
    titleNumber?: number;
    initialValues: AffiliationFormValues;
    setValues: (values: AffiliationValues) => void;
    setValidated: (b: boolean) => void;
    validated?: boolean;
}


export interface AffiliationValues {
    club?: Club;
    ligue?: Ligue;
}
export interface AffiliationFormValues {
    club: Club | undefined;
    ligue: string | undefined;
}


const AffiliationForm = (props: AffiliationFormProps) => {
    const {validated, setValidated} = props;
    const [close, setClose] = useState<boolean>(false)
    const [clubs, setClubs] = useState<Club[]>([])
    const [selectedClub, setSelectedClub] = useState<Club | undefined>(props.initialValues.club)
    const [ligues, setLigues] = useState<Ligue[]>([])
    const [isLoading, setIsLoading] = useState<boolean>(false)

    useEffect(() => {
        setIsLoading(true)
        getLigues().then((data: APIGetLiguesResponse) => {
            setLigues(data.ligues)
            setIsLoading(false)
        })
    }, [])

    type changeHandler = React.ChangeEventHandler<HTMLInputElement>;

    const handleChange: changeHandler = (e) => {
        const { target } = e;
        setValidated(false)
        if (!target.value.trim() || target.value.trim().length < 3)
            return setClubs([]);

        getClubs({txtSearch: target.value}).then((data: APIGetClubsResponse) => {
            !!data && !!data.clubs ? setClubs(data.clubs) : setClubs([])
        })
    };

    return (
        <Container
            id={"AffiliationFormContainer"}
            containerTitle={"Rattachement"}
            titleNumber={props.titleNumber}
            close={close}
            setClose={() => setClose(!close)}
            validated={validated}
        >
            {!isLoading ? (
                <Formik
                    validate={(values: AffiliationFormValues) => {
                        const errors: { [k: string]: string } = {};
                        if (!values.club && !values.ligue) {
                            errors.ligue = 'Veuillez choisir une ligue ou un club'
                            errors.club = 'Veuillez choisir une ligue ou un club'
                        } else if (values.club && clubs.length === 0) {
                            errors.club = "Veuillez sélectionner un club dans le menu déroulant"
                        }
                        return errors;
                    }}
                    initialValues={{
                        club: props.initialValues.club,
                        ligue: props.initialValues.ligue,
                    }}
                    onSubmit={(
                        values: AffiliationFormValues,
                        { setSubmitting }: FormikHelpers<AffiliationFormValues>
                    ) => {
                        props.setValues({
                            club: values.club,
                            ligue: ligues.filter((l: Ligue) => l.ST_CODE === values.ligue)[0]
                        });
                        setSubmitting(false);
                        setValidated(true);
                        props.setValidated(true);
                        setClose(true)
                        scrollToTop("AffiliationFormContainer")
                    }}
                >
                    <Form>
                        <LiveSearch
                            name={"club"}
                            label={"Trouver votre club de rattachement"}
                            placeholder={"Nom du club / Ville / Code postal"}
                            explication={"Sous réserve d’acceptation"}
                            results={
                                clubs.sort(
                                    (a: Club, b: Club) => a.ORDRE > b.ORDRE ? 1 : -1
                                )
                            }
                            renderItem={(item: Club) => <span>{item.ST_LIBELLE}</span>}
                            onChange={handleChange}
                            onSelect={setSelectedClub}
                            value={selectedClub?.ST_LIBELLE}
                        />
                        <div className={"flex gap-x-2 items-center"}>
                            <span className={"h-0.5 border-b border-grey--200 w-1/2"} />
                            <span className={"text-black font-medium ml-2 mr-2"}>OU</span>
                            <span className={"h-0.5 border-b border-grey--200  w-1/2"} />
                        </div>
                        <Field
                            id={"ligue"}
                            name={"ligue"}
                            as={"select"}
                            label={"Sélectionner une ligue de rattachement"}
                            explication={"Vous êtes libre de choisir votre Ligue (région) de rattachement en fonction notamment de votre domicile ou de votre lieu de pratique"}
                            onChange={() => {setValidated(false)}}
                        >
                            <option key={"empty"} value={""}>--</option>
                            {ligues.sort(
                                (a: Ligue, b: Ligue) => a.NOM > b.NOM ? 1 : -1
                            ).filter(
                                (l: Ligue) => l.ST_CODE !== '99'
                            ).map(
                                (l: Ligue) => <option key={l.ST_CODE} value={l.ST_CODE}>{l.NOM}</option>
                            )}
                        </Field>
                        <div className={"flex items-center justify-center md:justify-end"}>
                            <Button disabled={validated} type="submit">Confirmer</Button>
                        </div>
                    </Form>
                </Formik>
            ) : (<div>Loading</div>)}
        </Container>
    )
}

export default AffiliationForm;